module.exports = __webpack_public_path__ + "static/media/bac-minus.35c38931.svg";